import React from "react";
import { Router } from "lucide-react";

export function ServerCard() {
  return (
    <div
      className="bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl rounded-2xl p-4 border border-state-200/50 dark:border-slate-700/50 
           hover:shadow-xl hover:shadow-slate-900/20 transition-all duration-300 group "
    >
      {/* System matrics */}
      <div className="flex items-center justify-start space-x-2 space-y-2 mb-4">
        <Router className="w-4 h-4 text-black dark:text-slate-200" />
        <h2 className="text-sm font-bold text-black dark:text-slate-200">
          System Matrics
        </h2>
      </div>

      <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        {/* hostname */}
        <div className="flex flex-col items-start">
          <span className="text-xs text-black/50 dark:text-slate-500">
            Hostname
          </span>
          <span className="text-xs font-medium-200 text-black dark:text-slate-200 mt-1">
            cloudserver-panel
          </span>
        </div>

        {/* Operating System */}
        <div className="flex flex-col items-start">
          <span className="text-xs text-black/50 dark:text-slate-500">
            Operating System
          </span>
          <span className="text-xs font-medium-200 text-black dark:text-slate-200 mt-1">
            Ubuntu 22.04.5 LTS 64-bit
          </span>
        </div>

        {/* Uptime */}
        <div className="flex flex-col items-start">
          <span className="text-xs text-black/50 dark:text-slate-500">
            Uptime
          </span>
          <span className="text-xs font-medium-200 text-black dark:text-slate-200 mt-1">
            47 days, 3 hours
          </span>
        </div>

        {/* Load Average */}
        <div className="flex flex-col items-start">
          <span className="text-xs text-black/50 dark:text-slate-500">
            Load Average
          </span>
          <span className="text-xs font-medium-200 text-black dark:text-slate-200 mt-1">
            0.15, 0.10, 0.05
          </span>
        </div>

        
      </div>
    </div>
  );
}
